import React from "react";
import { BreadcrumbItem } from "reactstrap";
import { Route, Switch, Link } from "react-router-dom";
import * as Section from "@repoflow/components/section";
import * as ListRoute from "./list";

// Flatter than the files section next door, and deliberately so: the rows
// behind this screen are read-only (this service's own handlers write them,
// never a client) and have no stable single-row address to link to — the read
// path queries a time window — so there is no `new`, no `:captureId` and no
// entity route, only the one screen.
//
// Named `statistics` rather than `captures`, at the URL as well as in the
// labels. A capture is datum's word for a row on the wire; what this section
// answers is "what has this bucket done, and how much of its allowance is
// gone", and only one of those two is a capture at all — the limits half comes
// from the usage listing.
const LocalProvider = ({ match: { params }, children: Children }) => {
  const parent = Section.useSectionContext();
  const { base: parentBase, basepath: parentBasepath, schema } = parent;
  const base = `${parentBase}/statistics`;
  const basepath = `${parentBasepath}/statistics`;

  return (
    <Section.Provider
      schema={[...schema]}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, parent })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ basepath }) => (
        <Switch>
          <Route path={`${basepath}/`} component={ListRoute.Content} />
        </Switch>
      )}
    </LocalProvider>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath }) => (
        <>
          <BreadcrumbItem>
            <Link to={`${base}`}>Statistics</Link>
          </BreadcrumbItem>

          <Switch>
            <Route path={`${basepath}/`} component={ListRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => <>
</>;
